import {applyMiddleware, compose, createStore} from 'redux'
import {routerMiddleware} from 'react-router-redux'
import rootReducer from 'reducers/'
import createSagaMiddleware from 'redux-saga'
import createSocketMiddleware from './socketMiddleware'
import sagas from '../sagas'
import {loadConfig} from 'actions/config'

export default (history) => {
  let store = {}
  const sagaMiddleware = createSagaMiddleware()
  const middleware = [
    createSocketMiddleware(),
    sagaMiddleware,
    routerMiddleware(history),
  ]
  

  const enhancers = compose(
    applyMiddleware(...middleware),
    window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__({ trace: true, traceLimit: 25 }) : f => f
  )

  store = createStore(
    rootReducer,
    enhancers
  )

  if (module.hot) {
    module.hot.accept('reducers', () => {
      const nextRootReducer = require('reducers').default
      store.replaceReducer(nextRootReducer)
    })
  }

  sagaMiddleware.run(sagas)
  store.dispatch(loadConfig())

  return store
}
